import { GET_GROUPS, GET_GROUPS_SUCCESS, GET_GROUPS_FAILURE, RESET_GROUPS } from "../constants/GetGroups";
export const GetGroups = (data) => ({ type: GET_GROUPS, payload: data });
export const GetGroupsSuccess = (payload) => ({ type: GET_GROUPS_SUCCESS, payload });
export const GetGroupsFailure = (payload) => ({ type: GET_GROUPS_FAILURE, payload });
export const ResetGroups = () => ({ type: RESET_GROUPS });
